'use client';

import { RoaValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: RoaValues;
  onValuesChange: (field: keyof RoaValues, value: number) => void;
  translations: ToolsTranslations['roa'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof RoaValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.operatingIncome}</label>
        <input type="text" value={values.operatingIncome.toLocaleString('sv-SE')} onChange={handleChange('operatingIncome')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.interestExpense}</label>
        <input type="text" value={values.interestExpense.toLocaleString('sv-SE')} onChange={handleChange('interestExpense')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.equity}</label>
        <input type="text" value={values.equity.toLocaleString('sv-SE')} onChange={handleChange('equity')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.totalDebt}</label>
        <input type="text" value={values.totalDebt.toLocaleString('sv-SE')} onChange={handleChange('totalDebt')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


